import React from 'react';
import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';
import { getOrgStats, withOrg } from 'api/organizations';
import { AxiosError } from 'axios';
import { IError, handleAxiosError } from 'utils/handleAxiosError';
import Organization from 'containers/Organization';
import { MetaTags } from 'components/MetaTags';
import { isObjectId } from 'utils/validations';

type Props = InferGetStaticPropsType<typeof getStaticProps>;

const OrganizationHome: NextPage<Props> = ({ data, error }) => {
  if (!data) {
    return (
      <>
        <MetaTags title="Loading..." />

        <div>Loading...</div>
      </>
    );
  }

  if (error) {
    return (
      <div>
        {error.code} | {error.message}{' '}
      </div>
    );
  }
  return (
    <>
      <MetaTags title={data.organization.name} />

      <Organization organization={data.organization} organizationStats={data.organizationStats} />
    </>
  );
};

export const getStaticProps: GetStaticProps<
  {
    data?: { organization: MorressierOrganization; organizationStats: OrganizationStats };
    error?: IError;
  },
  { organization_id: string }
> = async ctx => {
  const organizationId = ctx.params?.organization_id;
  try {
    if (!isObjectId(organizationId)) throw new Error(`Invalid organization ID: ${organizationId}`);

    const [organization, organizationStats] = await withOrg(organizationId, () =>
      getOrgStats(organizationId),
    );

    return {
      props: { data: { organization, organizationStats } },
      revalidate: 60,
    };
  } catch (err) {
    const error = handleAxiosError(err as AxiosError);

    return {
      props: { error },
      revalidate: 60,
    };
  }
};

export const getStaticPaths: GetStaticPaths = async () => ({ paths: [], fallback: 'blocking' });

export default OrganizationHome;
